export const KG_SUBSECTION_MAX_CHILDREN = 3;
